// Code by Ruby - convx - 608
(function () {
  var panel = document.querySelector('[data-az-search]');
  if (!panel) return;

  var input = panel.querySelector('[data-az-search-input]');
  var closers = panel.querySelectorAll('[data-az-search-close]');
  var toggles = document.querySelectorAll('[data-az-search-toggle]');

  function isOpen() {
    return panel.classList.contains('is-open');
  }

  function openPanel() {
    panel.classList.add('is-open');
    document.body.classList.add('az-search-open');
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKeydown);
    if (input) {
      window.setTimeout(function () {
        input.focus();
      }, 50);
    }
  }

  function closePanel() {
    panel.classList.remove('is-open');
    document.body.classList.remove('az-search-open');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKeydown);
  }

  function onKeydown(event) {
    if (event.key === 'Escape' || event.code === 'Escape') closePanel();
  }

  function toggleClick() {
    if (isOpen()) {
      closePanel();
    } else {
      openPanel();
    }
  }

  toggles.forEach(function (toggle) {
    toggle.addEventListener('click', toggleClick);
    toggle.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ' || event.code === 'Space') {
        event.preventDefault();
        toggleClick();
      }
    });
  });

  closers.forEach(function (closer) {
    closer.addEventListener('click', closePanel);
  });

  var resultsRoot = panel.querySelector('[data-az-search-results]');
  if (!resultsRoot || !input) return;

  var idleView = resultsRoot.querySelector('[data-az-search-idle]');
  var liveView = resultsRoot.querySelector('[data-az-search-live]');
  var suggestionsEl = resultsRoot.querySelector('[data-az-search-suggestions]');
  var productsSectionEl = resultsRoot.querySelector('[data-az-search-products-section]');
  var productsEl = resultsRoot.querySelector('[data-az-search-products]');
  var viewAllEl = resultsRoot.querySelector('[data-az-search-view-all]');
  var noResultsEl = resultsRoot.querySelector('[data-az-search-no-results]');

  var i18n = {};
  var i18nScript = panel.querySelector('[data-az-search-i18n]');
  if (i18nScript) {
    try {
      i18n = JSON.parse(i18nScript.textContent);
    } catch (error) {
      i18n = {};
    }
  }

  function formatTemplate(template, values) {
    var result = template;
    Object.keys(values).forEach(function (key) {
      result = result.split('{{ ' + key + ' }}').join(values[key]);
    });
    return result;
  }

  function showIdle() {
    if (idleView) idleView.hidden = false;
    if (liveView) liveView.hidden = true;
  }

  function showLive() {
    if (idleView) idleView.hidden = true;
    if (liveView) liveView.hidden = false;
  }

  function clearChildren(el) {
    while (el && el.firstChild) el.removeChild(el.firstChild);
  }

  var SUGGESTION_ICON_SVG =
    '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
    '<circle cx="8.5" cy="8.5" r="6" fill="none" stroke="currentColor" stroke-width="1.5"/>' +
    '<line x1="13" y1="13" x2="18" y2="18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
    '</svg>';

  function renderSuggestions(queries) {
    if (!suggestionsEl) return;
    clearChildren(suggestionsEl);
    queries.forEach(function (query) {
      var link = document.createElement('a');
      link.className = 'az-search__suggestion';
      link.href = query.url;
      link.innerHTML =
        '<span class="az-search__suggestion-icon" aria-hidden="true">' +
        SUGGESTION_ICON_SVG +
        '</span><span>' +
        (query.styled_text || query.text) +
        '</span>';
      suggestionsEl.appendChild(link);
    });
  }

  function formatMoney(price) {
    if (typeof price === 'string' && price.trim() !== '') return price;
    var value = typeof price === 'object' && price !== null ? price.amount : price;
    var number = parseFloat(value);
    return isNaN(number) ? '' : number.toFixed(2);
  }

  function renderProducts(products) {
    if (!productsEl || !productsSectionEl) return;
    clearChildren(productsEl);

    if (!products.length) {
      productsSectionEl.hidden = true;
      return;
    }

    products.forEach(function (product) {
      var row = document.createElement('a');
      row.className = 'az-search__product';
      row.href = product.url;

      var media = document.createElement('span');
      media.className = 'az-search__product-media';
      if (product.image) {
        var img = document.createElement('img');
        img.src = product.image;
        img.alt = '';
        img.loading = 'lazy';
        media.appendChild(img);
      } else {
        media.classList.add('az-search__product-media--fallback');
        media.textContent = (product.title || '?').charAt(0).toUpperCase();
      }
      row.appendChild(media);

      var info = document.createElement('span');
      info.className = 'az-search__product-info';

      var title = document.createElement('span');
      title.className = 'az-search__product-title';
      title.textContent = product.title;
      info.appendChild(title);

      var variantTitle = product.variants && product.variants[0] && product.variants[0].title;
      if (variantTitle && variantTitle !== 'Default Title') {
        var meta = document.createElement('span');
        meta.className = 'az-search__product-meta';
        meta.textContent = variantTitle;
        info.appendChild(meta);
      }
      row.appendChild(info);

      var price = document.createElement('span');
      price.className = 'az-search__product-price';
      price.textContent = formatMoney(product.price);
      row.appendChild(price);

      productsEl.appendChild(row);
    });

    productsSectionEl.hidden = false;
  }

  function updateViewAllCount(term) {
    if (!viewAllEl) return;
    viewAllEl.hidden = true;

    var url = '/search?q=' + encodeURIComponent(term) + '&type=product';
    fetch(url)
      .then(function (response) {
        return response.ok ? response.text() : Promise.reject();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var searchSection = doc.getElementById('SearchPage');
        if (!searchSection) return;

        var count = parseInt(searchSection.getAttribute('data-search-results-count'), 10);
        if (isNaN(count)) return;

        var template = count === 1 ? i18n.viewAllOne : i18n.viewAllOther;
        template = template || 'View all {{ count }} {{ term }} results';
        viewAllEl.textContent = formatTemplate(template, { count: count, term: term });
        viewAllEl.href = '/search?options%5Bprefix%5D=last&q=' + encodeURIComponent(term);
        viewAllEl.hidden = count === 0;
      })
      .catch(function () {
      });
  }

  var activeController = null;
  var debounceTimer = null;

  function runSearch(rawQuery) {
    if (activeController) activeController.abort();
    activeController = window.AbortController ? new AbortController() : null;

    var term = rawQuery.trim();

    var suggestUrl =
      '/search/suggest.json?q=' +
      encodeURIComponent(term) +
      '&resources[type]=product,query&resources[limit]=6&resources[options][unavailable_products]=last';

    fetch(suggestUrl, activeController ? { signal: activeController.signal } : {})
      .then(function (response) {
        return response.ok ? response.json() : Promise.reject();
      })
      .then(function (data) {
        var results = (data.resources && data.resources.results) || {};
        var queries = results.queries || [];
        var products = results.products || [];

        renderSuggestions(queries);
        renderProducts(products);

        if (!queries.length && !products.length) {
          if (noResultsEl) {
            noResultsEl.textContent = formatTemplate(i18n.noResults || 'No results for {{ term }}', { term: term });
            noResultsEl.hidden = false;
          }
        } else if (noResultsEl) {
          noResultsEl.hidden = true;
        }

        if (products.length) {
          updateViewAllCount(term);
        } else if (viewAllEl) {
          viewAllEl.hidden = true;
        }
      })
      .catch(function () {
      });
  }

  input.addEventListener('input', function () {
    var value = input.value;
    window.clearTimeout(debounceTimer);

    if (!value.trim()) {
      showIdle();
      if (activeController) activeController.abort();
      return;
    }

    showLive();
    debounceTimer = window.setTimeout(function () {
      runSearch(value);
    }, 300);
  });
})();
